

import React, { useState, useEffect } from 'react';
import './GeneralQuiz.css';

const questions = [
    {
      question: "What is the capital of France?",
      options: ["Berlin", "Madrid", "Paris", "Lisbon"],
      correctAnswer: "Paris"
    },
    {
      question: "Which planet is known as the Red Planet?",
      options: ["Earth", "Mars", "Jupiter", "Saturn"],
      correctAnswer: "Mars"
    },
    {
      question: "Who wrote 'Hamlet'?",
      options: ["Charles Dickens", "Mark Twain", "William Shakespeare", "Leo Tolstoy"],
      correctAnswer: "William Shakespeare"
    },
    {
      question: "What is the largest ocean on Earth?",
      options: ["Atlantic Ocean", "Indian Ocean", "Arctic Ocean", "Pacific Ocean"],
      correctAnswer: "Pacific Ocean"
    },
    {
      question: "Who painted the Mona Lisa?",
      options: ["Vincent van Gogh", "Pablo Picasso", "Leonardo da Vinci", "Claude Monet"],
      correctAnswer: "Leonardo da Vinci"
    },
    {
      question: "What is the capital of Japan?",
      options: ["Beijing", "Seoul", "Tokyo", "Bangkok"],
      correctAnswer: "Tokyo"
    },
    {
      question: "What is the hardest natural substance on Earth?",
      options: ["Gold", "Diamond", "Iron", "Platinum"],
      correctAnswer: "Diamond"
    },
    {
      question: "Who developed the theory of relativity?",
      options: ["Isaac Newton", "Albert Einstein", "Galileo Galilei", "Nikola Tesla"],
      correctAnswer: "Albert Einstein"
    },
    {
      question: "What is the smallest country in the world?",
      options: ["Monaco", "San Marino", "Liechtenstein", "Vatican City"],
      correctAnswer: "Vatican City"
    },
    {
      question: "Which planet is closest to the sun?",
      options: ["Venus", "Mars", "Mercury", "Jupiter"],
      correctAnswer: "Mercury"
    },
    {
      question: "What is the tallest mountain in the world?",
      options: ["K2", "Kangchenjunga", "Mount Everest", "Lhotse"],
      correctAnswer: "Mount Everest"
    },
    {
      question: "Who invented the telephone?",
      options: ["Thomas Edison", "Alexander Graham Bell", "Nikola Tesla", "Guglielmo Marconi"],
      correctAnswer: "Alexander Graham Bell"
    },
    {
      question: "What is the chemical symbol for gold?",
      options: ["Au", "Ag", "Pb", "Fe"],
      correctAnswer: "Au"
    },
    {
      question: "Which country is known as the Land of the Rising Sun?",
      options: ["China", "Japan", "Thailand", "Vietnam"],
      correctAnswer: "Japan"
    },
    {
      question: "What is the largest continent by land area?",
      options: ["Africa", "Asia", "Europe", "North America"],
      correctAnswer: "Asia"
    },
    {
      question: "Who discovered penicillin?",
      options: ["Marie Curie", "Alexander Fleming", "Louis Pasteur", "Gregor Mendel"],
      correctAnswer: "Alexander Fleming"
    },
    {
      question: "Which element is said to keep bones strong?",
      options: ["Potassium", "Calcium", "Iron", "Zinc"],
      correctAnswer: "Calcium"
    },
    {
      question: "What is the longest river in the world?",
      options: ["Amazon River", "Nile River", "Yangtze River", "Mississippi River"],
      correctAnswer: "Nile River"
    },
    {
      question: "Which is the largest desert in the world?",
      options: ["Sahara Desert", "Arabian Desert", "Gobi Desert", "Kalahari Desert"],
      correctAnswer: "Sahara Desert"
    },
    {
      question: "Who was the first President of the United States?",
      options: ["Abraham Lincoln", "George Washington", "Thomas Jefferson", "John Adams"],
      correctAnswer: "George Washington"
    },
    {
      question: "What is the largest planet in our solar system?",
      options: ["Earth", "Saturn", "Jupiter", "Neptune"],
      correctAnswer: "Jupiter"
    },
    {
      question: "Which ocean lies on the east coast of the United States?",
      options: ["Indian Ocean", "Pacific Ocean", "Atlantic Ocean", "Arctic Ocean"],
      correctAnswer: "Atlantic Ocean"
    },
    {
      question: "Who is known as the father of computers?",
      options: ["Charles Babbage", "Alan Turing", "John von Neumann", "Bill Gates"],
      correctAnswer: "Charles Babbage"
    },
    {
      question: "What is the main ingredient in guacamole?",
      options: ["Tomato", "Onion", "Avocado", "Pepper"],
      correctAnswer: "Avocado"
    },
    {
      question: "Who was the first man to walk on the moon?",
      options: ["Yuri Gagarin", "Buzz Aldrin", "Michael Collins", "Neil Armstrong"],
      correctAnswer: "Neil Armstrong"
    },
    {
      question: "What is the currency of Japan?",
      options: ["Yuan", "Yen", "Won", "Rupee"],
      correctAnswer: "Yen"
    },
    {
      question: "What is the speed of light?",
      options: ["300,000 km/s", "150,000 km/s", "200,000 km/s", "350,000 km/s"],
      correctAnswer: "300,000 km/s"
    },
    {
      question: "Which blood type is known as the universal donor?",
      options: ["A", "B", "AB", "O"],
      correctAnswer: "O"
    },
    {
      question: "Which country is known as the Land Down Under?",
      options: ["South Africa", "New Zealand", "Australia", "Fiji"],
      correctAnswer: "Australia"
    },
    {
      question: "Which language is the most spoken worldwide?",
      options: ["Spanish", "English", "Hindi", "Mandarin"],
      correctAnswer: "Mandarin"
    },
    {
      question: "Who was the first female Prime Minister of India?",
      options: ["Sonia Gandhi", "Indira Gandhi", "Pratibha Patil", "Mamta Banerjee"],
      correctAnswer: "Indira Gandhi"
    },
    {
      question: "Which city is known as the Silicon Valley of India?",
      options: ["Mumbai", "Chennai", "Hyderabad", "Bangalore"],
      correctAnswer: "Bangalore"
    },
    {
      question: "What is the national animal of India?",
      options: ["Elephant", "Tiger", "Peacock", "Lion"],
      correctAnswer: "Tiger"
    },
    {
      question: "Which river is considered the holiest in India?",
      options: ["Yamuna", "Ganga", "Narmada", "Godavari"],
      correctAnswer: "Ganga"
    },
    {
      question: "In which year did India gain independence?",
      options: ["1942", "1945", "1947", "1950"],
      correctAnswer: "1947"
    },
    {
      question: "What is the highest civilian award in India?",
      options: ["Padma Shri", "Padma Bhushan", "Padma Vibhushan", "Bharat Ratna"],
      correctAnswer: "Bharat Ratna"
    },
    {
      question: "Which Indian state has the highest population?",
      options: ["Bihar", "Maharashtra", "Uttar Pradesh", "West Bengal"],
      correctAnswer: "Uttar Pradesh"
    },
    {
      question: "What is the official language of India?",
      options: ["Hindi", "English", "Bengali", "Tamil"],
      correctAnswer: "Hindi"
    },
    {
      question: "Which Indian city is known as the Pink City?",
      options: ["Udaipur", "Jaipur", "Jodhpur", "Agra"],
      correctAnswer: "Jaipur"
    },
    {
      question: "Who is the author of 'India Wins Freedom'?",
      options: ["Mahatma Gandhi", "Jawaharlal Nehru", "Subhash Chandra Bose", "Maulana Abul Kalam Azad"],
      correctAnswer: "Maulana Abul Kalam Azad"
    },
    {
      question: "What is the national sport of India?",
      options: ["Cricket", "Hockey", "Kabaddi", "Badminton"],
      correctAnswer: "Hockey"
    },
    {
      question: "Which state is known as the Spice Garden of India?",
      options: ["Kerala", "Tamil Nadu", "Karnataka", "Assam"],
      correctAnswer: "Kerala"
    },
    {
      question: "Who is known as the Iron Man of India?",
      options: ["Mahatma Gandhi", "Sardar Vallabhbhai Patel", "Subhash Chandra Bose", "Lal Bahadur Shastri"],
      correctAnswer: "Sardar Vallabhbhai Patel"
    },
    {
      question: "Which Indian festival is known as the festival of lights?",
      options: ["Holi", "Diwali", "Dussehra", "Navratri"],
      correctAnswer: "Diwali"
    },
    
    
        // Questions on inventions
        {
          question: "Who invented the light bulb?",
          options: ["Thomas Edison", "Nikola Tesla", "Alexander Graham Bell", "Isaac Newton"],
          correctAnswer: "Thomas Edison"
        },
        {
          question: "Who is known for inventing the telephone?",
          options: ["Thomas Edison", "Nikola Tesla", "Alexander Graham Bell", "Guglielmo Marconi"],
          correctAnswer: "Alexander Graham Bell"
        },
        {
          question: "Who invented the World Wide Web?",
          options: ["Bill Gates", "Steve Jobs", "Tim Berners-Lee", "Mark Zuckerberg"],
          correctAnswer: "Tim Berners-Lee"
        },
        {
          question: "Which scientist is known for inventing the first practical telephone?",
          options: ["Thomas Edison", "Nikola Tesla", "Alexander Graham Bell", "Albert Einstein"],
          correctAnswer: "Alexander Graham Bell"
        },
        {
          question: "Who invented the steam engine?",
          options: ["James Watt", "George Stephenson", "Nikola Tesla", "Thomas Edison"],
          correctAnswer: "James Watt"
        },
      
        // Questions on computers
        {
          question: "Who is known as the father of computers?",
          options: ["Charles Babbage", "Alan Turing", "John von Neumann", "Bill Gates"],
          correctAnswer: "Charles Babbage"
        },
        {
          question: "What does CPU stand for?",
          options: ["Central Processing Unit", "Central Programming Unit", "Computer Processing Unit", "Computer Programming Unit"],
          correctAnswer: "Central Processing Unit"
        },
        {
          question: "Which company developed the first personal computer?",
          options: ["Microsoft", "IBM", "Apple", "Intel"],
          correctAnswer: "IBM"
        },
        {
          question: "What is the name of the first computer virus?",
          options: ["ILOVEYOU", "Creeper", "Melissa", "Conficker"],
          correctAnswer: "Creeper"
        },
        {
          question: "Which programming language is known as the mother of all languages?",
          options: ["Python", "C", "Assembly", "FORTRAN"],
          correctAnswer: "C"
        },
      
        // Questions on Egyptian history
        {
          question: "Who was the first pharaoh of Egypt?",
          options: ["Ramses II", "Tutankhamun", "Narmer", "Cleopatra"],
          correctAnswer: "Narmer"
        },

            {
              question: "Which pharaoh built the Great Pyramid of Giza?",
              options: ["Tutankhamun", "Ramesses II", "Khufu", "Cleopatra"],
              correctAnswer: "Khufu"
            },
            {
              question: "What is the process of preserving a body in ancient Egypt called?",
              options: ["Mummification", "Embalming", "Incantation", "Anointment"],
              correctAnswer: "Mummification"
            },
            {
              question: "Which river was vital to ancient Egyptian civilization?",
              options: ["Nile", "Tigris", "Euphrates", "Amazon"],
              correctAnswer: "Nile"
            },
            {
              question: "What is the ancient Egyptian writing system called?",
              options: ["Cuneiform", "Hieroglyphics", "Latin", "Sanskrit"],
              correctAnswer: "Hieroglyphics"
            },
            {
              question: "Who was the first person to circumnavigate the globe?",
              options: ["Christopher Columbus", "Ferdinand Magellan", "Marco Polo", "James Cook"],
              correctAnswer: "Ferdinand Magellan"
            },
            {
              question: "Which scientist is known for the law of universal gravitation?",
              options: ["Albert Einstein", "Isaac Newton", "Galileo Galilei", "Niels Bohr"],
              correctAnswer: "Isaac Newton"
            },
            {
              question: "What is the chemical formula for water?",
              options: ["H2O", "CO2", "O2", "H2"],
              correctAnswer: "H2O"
            },
            {
              question: "What is the powerhouse of the cell?",
              options: ["Nucleus", "Ribosome", "Mitochondria", "Chloroplast"],
              correctAnswer: "Mitochondria"
            },
            {
              question: "Who invented the light bulb?",
              options: ["Nikola Tesla", "Alexander Graham Bell", "Thomas Edison", "George Westinghouse"],
              correctAnswer: "Thomas Edison"
            },
            {
              question: "Which gas is most abundant in Earth's atmosphere?",
              options: ["Oxygen", "Hydrogen", "Nitrogen", "Carbon Dioxide"],
              correctAnswer: "Nitrogen"
            },
            {
              question: "What is the name of the first artificial Earth satellite?",
              options: ["Voyager 1", "Sputnik 1", "Apollo 11", "Hubble"],
              correctAnswer: "Sputnik 1"
            },
            {
              question: "Which Indian scientist won the Nobel Prize in Physics in 1930?",
              options: ["C.V. Raman", "Homi J. Bhabha", "Satyendra Nath Bose", "Vikram Sarabhai"],
              correctAnswer: "C.V. Raman"
            },
            {
              question: "Which Indian river is known as the 'Sorrow of Bihar'?",
              options: ["Ganga", "Yamuna", "Kosi", "Godavari"],
              correctAnswer: "Kosi"
            },
            {
              question: "What is the main constituent of the sun?",
              options: ["Oxygen", "Nitrogen", "Hydrogen", "Helium"],
              correctAnswer: "Hydrogen"
            },
            {
              question: "Who discovered the vaccine for polio?",
              options: ["Albert Sabin", "Edward Jenner", "Jonas Salk", "Louis Pasteur"],
              correctAnswer: "Jonas Salk"
            },
            {
              question: "Which Indian state is known for tea production?",
              options: ["Assam", "Kerala", "Gujarat", "Punjab"],
              correctAnswer: "Assam"
            },
            {
              question: "Which famous Indian monument was built by Emperor Shah Jahan?",
              options: ["Qutub Minar", "Taj Mahal", "Red Fort", "Gateway of India"],
              correctAnswer: "Taj Mahal"
            },
            {
              question: "Who was the first person to reach the South Pole?",
              options: ["Ernest Shackleton", "Roald Amundsen", "Robert Falcon Scott", "James Clark Ross"],
              correctAnswer: "Roald Amundsen"
            },
            {
              question: "Which element has the atomic number 1?",
              options: ["Helium", "Oxygen", "Hydrogen", "Carbon"],
              correctAnswer: "Hydrogen"
            },
            {
              question: "What is the primary source of energy for life on Earth?",
              options: ["Water", "Wind", "Solar energy", "Geothermal energy"],
              correctAnswer: "Solar energy"
            },
            {
              question: "Who is known as the Missile Man of India?",
              options: ["Vikram Sarabhai", "A.P.J. Abdul Kalam", "Satish Dhawan", "Raja Ramanna"],
              correctAnswer: "A.P.J. Abdul Kalam"
            },
            {
              question: "Which Indian festival celebrates the victory of light over darkness?",
              options: ["Holi", "Dussehra", "Diwali", "Raksha Bandhan"],
              correctAnswer: "Diwali"
            },
            {
              question: "Who was the first Emperor of unified China?",
              options: ["Liu Bang", "Qin Shi Huang", "Emperor Wu", "Kublai Khan"],
              correctAnswer: "Qin Shi Huang"
            },
            {
              question: "Which is the largest gland in the human body?",
              options: ["Pancreas", "Thyroid", "Liver", "Adrenal"],
              correctAnswer: "Liver"
            },
            {
              question: "What is the process by which plants make their food?",
              options: ["Respiration", "Transpiration", "Photosynthesis", "Digestion"],
              correctAnswer: "Photosynthesis"
            },
            {
              question: "Who is known as the 'Father of Genetics'?",
              options: ["Charles Darwin", "Gregor Mendel", "James Watson", "Francis Crick"],
              correctAnswer: "Gregor Mendel"
            },
            {
              question: "What is the main chemical element in steel?",
              options: ["Carbon", "Iron", "Copper", "Zinc"],
              correctAnswer: "Iron"
            },
            {
              question: "What is the name of the Egyptian sun god?",
              options: ["Horus", "Osiris", "Ra", "Anubis"],
              correctAnswer: "Ra"
            },
            {
              question: "Which element is used in pencils?",
              options: ["Lead", "Graphite", "Charcoal", "Ink"],
              correctAnswer: "Graphite"
            },
            {
              question: "Who was the first Indian woman in space?",
              options: ["Kalpana Chawla", "Sunita Williams", "Indira Gandhi", "Kiran Bedi"],
              correctAnswer: "Kalpana Chawla"
            },
            {
              question: "What is the study of fossils called?",
              options: ["Geology", "Archaeology", "Paleontology", "Anthropology"],
              correctAnswer: "Paleontology"
            },
            {
              question: "Which river flows through Egypt?",
              options: ["Amazon", "Yangtze", "Nile", "Mississippi"],
              correctAnswer: "Nile"
            },
            {
              question: "Who wrote the Indian national anthem?",
              options: ["Mahatma Gandhi", "Rabindranath Tagore", "Sarojini Naidu", "Sardar Patel"],
              correctAnswer: "Rabindranath Tagore"
            },
            {
              question: "Which part of the cell contains genetic material?",
              options: ["Nucleus", "Ribosome", "Cytoplasm", "Golgi apparatus"],
              correctAnswer: "Nucleus"
            },
            {
              question: "What is the largest island in the world?",
              options: ["Greenland", "Madagascar", "Borneo", "New Guinea"],
              correctAnswer: "Greenland"
            },
            
        
  // Add more questions as needed
];

const shuffleArray = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

const GeneralQuiz = () => {
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [feedback, setFeedback] = useState("");

  useEffect(() => {
    setShuffledQuestions(shuffleArray([...questions]));
  }, []);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = () => {
    const currentQuestion = shuffledQuestions[currentQuestionIndex];
    if (selectedOption === currentQuestion.correctAnswer) {
      setFeedback("Correct!");
      speechSynthesis.speak(new SpeechSynthesisUtterance("Hurrreeeey!...Right answer"));
    } else {
      setFeedback(`Wrong! The correct answer is ${currentQuestion.correctAnswer}.`);
      speechSynthesis.speak(new SpeechSynthesisUtterance("ohh...!,Wrong answer"));
    }
  };

  const handleNextQuestion = () => {
    setSelectedOption(null);
    setFeedback("");
    setCurrentQuestionIndex((prevIndex) => (prevIndex + 1) % shuffledQuestions.length);
  };

  const currentQuestion = shuffledQuestions[currentQuestionIndex];

  return (
    <div className="quiz">
      <h1>General Knowledge Quiz</h1>
      {currentQuestion && (
        <div className="card">
          <div className="question">
            <h2>{currentQuestion.question}</h2>
            {currentQuestion.options.map((option, index) => (
              <label key={index} className="option">
                <input
                  type="radio"
                  name="option"
                  value={option}
                  checked={selectedOption === option}
                  onChange={handleOptionChange}
                />
                {option}
              </label>
            ))}
          </div>
          <button onClick={handleSubmit}>Submit</button>
          {feedback && (
            <div className="feedback">
              <p>{feedback}</p>
              <button onClick={handleNextQuestion}>Next Question</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GeneralQuiz;
